module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBold.dc33aefe.woff";